"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "START_DATE", {
  enumerable: true,
  get: function get() {
    return _constants.START_DATE;
  }
});

_Object$defineProperty(exports, "END_DATE", {
  enumerable: true,
  get: function get() {
    return _constants.END_DATE;
  }
});

exports.kind = void 0;

var _constants = require("react-dates/lib/constants");

var kind = {
  EMBEDDED: "embedded",
  BORDERED: "bordered"
};
exports.kind = kind;
//# sourceMappingURL=types.js.map